(() => {
  angular.module('finance').component('genericInvoiceDetailDetailedChargesComponent', {
    templateUrl: require('./genericDetailedCharges.component.html'),
    controller: GenericInvoiceDetailDetailedChargesComponent,
    controllerAs: 'vm',
    bindings: {
      invoice: '<',
      getDateString: '<'
    },
  });

  GenericInvoiceDetailDetailedChargesComponent.$inject = [];

  function GenericInvoiceDetailDetailedChargesComponent() {
    const vm = this;

    vm.loading = 0;
    vm.isDate = function(item) {
      return App.isDate(item);
    };

    init();

    function init() {}
  }
})();
